import {
  settingSVG,
  pspSvg,
  designSVG,
  shipSVG,
  notificationSVG,
  marketingSVG,
  classesSVG,
  dashboardSVG,
  discountsSVG,
  securitySVG,
  subscribeSVG,
  webhookSVG,
  RecommendationsSVG,
  userSettingSVG,
  rocketSVG,
  eventSVG,
  keySVG,
  equalizerSVG,
  databaseLargeSVG,
  chatSVG,
  shopSVG,
  aiGenerateSVG,
  tickWithCircleSVG,
  historySVG,
} from '../allCustomSVGs';
import { allRoutes } from './route';

// Define the SidebarLink type
type SidebarLink = {
  icon: string | JSX.Element;
  iconType: string;
  title: string;
  link: string;
  urlName: string;
  level: number;
  specialURL?: string;
};

// Define the type for all routes keys
type RouteKey = keyof typeof allRoutes;

export const linksDashboard: SidebarLink[] = [
  {
    icon: dashboardSVG,
    iconType: 'svg',
    title: 'StatsDashboard',
    link: '/dashboard',
    urlName: 'dashboard',
    level: 1,
  },
];

export const linksClients: SidebarLink[] = [
  {
    icon: shopSVG,
    iconType: 'svg',
    title: 'Clients',
    link: '/clients',
    urlName: 'clients',
    level: 1,
  },
];

export const linksIntegrations: SidebarLink[] = [
  {
    icon: databaseLargeSVG,
    iconType: 'svg',
    title: 'Integrations',
    link: '/integrations',
    urlName: 'integrations',
    level: 1,
  },
];

export const linksReports: SidebarLink[] = [
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Notifications',
    link: '/reports/notifications',
    urlName: 'notifications',
    specialURL: '/reports/notifications',
    level: 2,
  },
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Presentations',
    link: '/reports/presentations',
    urlName: 'presentations',
    specialURL: '/reports/presentations',
    level: 2,
  },
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Custom Prompts',
    link: '/reports/prompts',
    urlName: 'prompts',
    specialURL: '/reports/prompts',
    level: 2,
  },
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Graphs',
    link: '/reports/graphs',
    urlName: 'graphs',
    specialURL: '/reports/graphs',
    level: 2,
  },
  // {
  //   icon: settingSVG,
  //   iconType: 'svg',
  //   title: 'Settings',
  //   link: '/insights/settings',
  //   urlName: 'settings',
  //   specialURL: '/insights/settings',
  //   level: 2,
  // },
];

export const linksAIOptimizations: SidebarLink[] = [
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Automated',
    link: '/ai-optimizations/automated',
    urlName: 'automated',
    specialURL: '/ai-optimizations/automated',
    level: 2,
  },
  {
    icon: settingSVG,
    iconType: 'svg',
    title: 'Manual',
    link: '/ai-optimizations/manual',
    urlName: 'manual',
    specialURL: '/ai-optimizations/manual',
    level: 2,
  },
];

export const linksActions: SidebarLink[] = [
  {
    icon: tickWithCircleSVG,
    iconType: 'svg',
    title: 'Action Queue',
    link: '/actions/queue',
    urlName: 'queue',
    specialURL: '/actions/queue',
    level: 2,
  },
  {
    icon: historySVG,
    iconType: 'svg',
    title: 'Action History',
    link: '/actions/history',
    urlName: 'history',
    specialURL: '/actions/history',
    level: 2,
  },
  {
    icon: settingSVG,
    iconType: 'svg',
    title: 'Action Settings',
    link: '/actions/settings',
    urlName: 'settings',
    specialURL: '/actions/settings',
    level: 2,
  },
  {
    icon: equalizerSVG,
    iconType: 'svg',
    title: 'Auto-Approval Rules',
    link: '/actions/rules',
    urlName: 'rules',
    specialURL: '/actions/rules',
    level: 2,
  },
];

export const linksRecommendations: SidebarLink[] = [
  {
    icon: RecommendationsSVG,
    iconType: 'svg',
    title: 'Recommendations',
    link: '/recommendations',
    urlName: 'recommendations',
    level: 1,
  },
];

export const linksTracking: SidebarLink[] = [
  {
    icon: rocketSVG,
    iconType: 'svg',
    title: 'Integration',
    link: '/tracking/integration',
    urlName: 'integration',
    level: 2,
  },
  {
    icon: classesSVG,
    iconType: 'svg',
    title: 'CSSTracking',
    link: '/tracking/css',
    urlName: 'css',
    level: 2,
  },
  {
    icon: eventSVG,
    iconType: 'svg',
    title: 'EventTracking',
    link: '/tracking/events',
    urlName: 'events',
    level: 2,
  },
  // {
  //   icon: autofillSVG,
  //   iconType: 'svg',
  //   title: 'Autofill',
  //   link: '/tracking/autofill',
  //   urlName: 'autofill',
  //   level: 2,
  // },
];

export const linksSettings: SidebarLink[] = [
  {
    icon: settingSVG,
    iconType: 'svg',
    title: 'General',
    link: '/settings/general',
    urlName: 'general',
    level: 2,
  },
  {
    icon: userSettingSVG,
    iconType: 'svg',
    title: 'Profile',
    link: '/settings/profile',
    urlName: 'profile',
    level: 2,
  },
  {
    icon: shopSVG,
    iconType: 'svg',
    title: 'Brands',
    link: '/settings/brand',
    urlName: 'brand',
    level: 2,
  },
  {
    icon: chatSVG,
    iconType: 'svg',
    title: 'Communication',
    link: '/settings/communication',
    urlName: 'communication',
    level: 2,
  },
  {
    icon: subscribeSVG,
    iconType: 'svg',
    title: 'Subscription',
    link: '/settings/subscription',
    urlName: 'subscription',
    level: 2,
  },
  {
    icon: keySVG,
    iconType: 'svg',
    title: 'API Keys',
    link: '/settings/api-keys',
    urlName: 'api-keys',
    level: 2,
  },
  {
    icon: aiGenerateSVG,
    iconType: 'svg',
    title: 'Tara',
    link: '/settings/tara',
    urlName: 'tara',
    level: 2,
  },
  {
    icon: designSVG,
    iconType: 'svg',
    title: 'Appearance',
    link: '/settings/appearance',
    urlName: 'appearance',
    level: 2,
  },
  {
    icon: pspSvg,
    iconType: 'svg',
    title: 'Payments',
    link: '/settings/payments',
    urlName: 'payments',
    level: 2,
  },
  {
    icon: shipSVG,
    iconType: 'svg',
    title: 'Shipping',
    link: '/settings/shipping',
    urlName: 'shipping',
    level: 2,
  },
  {
    icon: pspSvg,
    iconType: 'svg',
    title: 'ConvenienceFee',
    link: '/settings/convenienceFee',
    urlName: 'convenienceFee',
    level: 2,
  },
  {
    icon: discountsSVG,
    iconType: 'svg',
    title: 'Discounts',
    link: '/settings/discounts',
    urlName: 'discounts',
    level: 2,
  },
  {
    icon: notificationSVG,
    iconType: 'svg',
    title: 'Notifications',
    link: '/settings/notifications',
    urlName: 'notifications',
    level: 2,
  },
  {
    icon: webhookSVG,
    iconType: 'svg',
    title: 'Webhooks',
    link: '/settings/webhooks',
    urlName: 'webhooks',
    level: 2,
  },
  {
    icon: marketingSVG,
    iconType: 'svg',
    title: 'Marketing',
    link: '/settings/marketing',
    urlName: 'marketing',
    level: 2,
  },
  {
    icon: securitySVG,
    iconType: 'svg',
    title: 'Security',
    link: '/settings/security',
    urlName: 'security',
    level: 2,
  },
];

export const sellerAllSidebarLinks: SidebarLink[] = [
  ...linksDashboard,
  ...linksClients,
  ...linksIntegrations,
  ...linksActions,
  ...linksReports,
  ...linksAIOptimizations,
  ...linksRecommendations,
  ...linksTracking,
  ...linksSettings,
].filter((link) => allRoutes[link.link as RouteKey]);
